export function napcatLoginRecoveryActionLabel(action?: unknown) {
  const labels: Record<string, string> = {
    scan_qrcode: "扫码登录",
    quick_login: "快速登录",
    refresh_qrcode: "刷新二维码",
    confirm_online: "等待在线确认",
    request_qrcode: "获取二维码"
  };
  return labels[String(action || "")] || String(action || "-");
}
